const INITIAL_STATE = [{ isCollapsed: false }]

export default function(state = INITIAL_STATE, action = []) {
  if (action.type === 'TOGGLE_COLLAPSE') {
    return [{ isCollapsed: action.collapsed }]
  }
  return state
}
